import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import YoutubeVideoFalse from 'components/Motion_Detection/INSTAR_Cloud/Alarm_Recordings/YoutubeVideoCardCloudFalseAlert';
import YoutubeVideoRec from 'components/Motion_Detection/INSTAR_Cloud/Alarm_Recordings/YoutubeVideoCardCloud';
import NavButtons from 'components/Motion_Detection/INSTAR_Cloud/NavButtons';
import ForumBox from 'components/Motion_Detection/INSTAR_Cloud/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  YoutubeVideoFalse,
  YoutubeVideoRec,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};